import React from "react";
import "./PepAnswers.scss";
import { getRoleAlts, getMilitaryAlts } from "../pages/RolePage/RolePage";
import { PepType } from "../pages/PepContext";
import { useIntl, defineMessages, FormattedMessage } from "react-intl";
import { messages as isPepMessages } from "../pages/IsPep/IsPepMessages";
import { relationMessages, businessRelationMessages, } from "../pages/RelationPage/RelationMessages";
const messages = defineMessages({
    whoIsPepLabel: {
        id: "pep.answers.who.label",
    },
    relationLabel: {
        id: "pep.answers.relationship.label",
    },
    businessRelationLabel: {
        id: "pep.answers.businessRelationship.label",
    },
    nameOfPepLabel: {
        id: "pep.answers.nameOfPep.label",
    },
    birthdayOfPEPLabel: {
        id: "pep.answers.birthdayOfPEP.label",
    },
    statusLabel: {
        id: "pep.answers.status.label",
    },
    statusEndedValue: {
        id: "pep.answers.statusEnded.value",
    },
    statusOngoingValue: {
        id: "pep.answers.statusOngoing.value",
    },
    endedLabel: {
        id: "pep.answers.endedStatus.label",
    },
    roleLabel: {
        id: "pep.answers.role.label",
    },
    countryLabel: {
        id: "pep.answers.country.label",
    },
    ambassadorCountryLabel: {
        id: "pep.answers.ambassadorCountry.label",
    },
    governmentCompanyNameLabel: {
        id: "pep.answers.governmentCompanyName.label",
    },
    governmentCompanyRoleLabel: {
        id: "pep.answers.governmentCompanyRole.label",
    },
    internationalOrganisationNameLabel: {
        id: "pep.answers.companyName.label",
    },
    internationalOrganisationRoleLabel: {
        id: "pep.answers.companyRole.label",
    },
    militaryGradeLabel: {
        id: "pep.answers.militaryRank.label",
    },
});
export const PepAnswers = ({ answer }) => {
    const intl = useIntl();
    if (!answer.type || answer.type === PepType.NOT_PEP) {
        return (React.createElement("div", null,
            React.createElement("p", null,
                React.createElement(FormattedMessage, { id: "pep.answers.notpep" }))));
    }
    const entityType = answer.legalEntityType;
    const role = getRoleAlts(intl).find((alt) => alt.value === answer.role);
    const militaryRank = getMilitaryAlts(intl).find((alt) => alt.value === answer.militaryRank);
    return (React.createElement("div", null,
        answer.type && (React.createElement(StaticInput, { label: intl.formatMessage(messages.whoIsPepLabel), value: intl.formatMessage(isPepMessages[answer.type], {
                entityType,
                name: answer.ownerName,
            }) })),
        answer.relationToPEP && (React.createElement(StaticInput, { label: intl.formatMessage(messages.relationLabel), value: intl.formatMessage(relationMessages[answer.relationToPEP], {
                entityType,
                name: answer.ownerName,
            }) })),
        answer.businessRelation && (React.createElement(StaticInput, { label: intl.formatMessage(messages.businessRelationLabel), value: intl.formatMessage(businessRelationMessages[answer.businessRelation], { entityType, name: answer.ownerName }) })),
        answer.nameOfPEP && (React.createElement(StaticInput, { label: intl.formatMessage(messages.nameOfPepLabel), value: answer.nameOfPEP })),
        answer.birthdayOfPEP && (React.createElement(StaticInput, { label: intl.formatMessage(messages.birthdayOfPEPLabel), value: answer.birthdayOfPEP })),
        answer.ended ? (React.createElement(React.Fragment, null,
            React.createElement(StaticInput, { label: intl.formatMessage(messages.statusLabel), value: intl.formatMessage(messages.statusEndedValue) }),
            React.createElement(StaticInput, { label: intl.formatMessage(messages.endedLabel), value: answer.ended }))) : (React.createElement(StaticInput, { label: intl.formatMessage(messages.statusLabel), value: intl.formatMessage(messages.statusOngoingValue) })),
        answer.country && (React.createElement(StaticInput, { label: intl.formatMessage(messages.countryLabel), value: intl.formatDisplayName(answer.country, { type: "region" }) })),
        role && (React.createElement(StaticInput, { label: intl.formatMessage(messages.roleLabel), value: role.text })),
        answer.ambassadorCountry && (React.createElement(StaticInput, { label: intl.formatMessage(messages.ambassadorCountryLabel), value: intl.formatDisplayName(answer.ambassadorCountry, {
                type: "region",
            }) })),
        answer.governmentCompany && (React.createElement(StaticInput, { label: intl.formatMessage(messages.governmentCompanyNameLabel), value: answer.governmentCompany })),
        answer.governmentCompanyRole && (React.createElement(StaticInput, { label: intl.formatMessage(messages.governmentCompanyRoleLabel), value: answer.governmentCompanyRole })),
        answer.internationalOrganisation && (React.createElement(StaticInput, { label: intl.formatMessage(messages.internationalOrganisationNameLabel), value: answer.internationalOrganisation })),
        answer.internationalOrganisationRole && (React.createElement(StaticInput, { label: intl.formatMessage(messages.internationalOrganisationRoleLabel), value: answer.internationalOrganisationRole })),
        militaryRank && (React.createElement(StaticInput, { label: intl.formatMessage(messages.militaryGradeLabel), value: militaryRank.text }))));
};
const StaticInput = ({ label, value }) => {
    return (React.createElement("div", { className: "static-input" },
        React.createElement("div", { className: "label" }, label),
        React.createElement("div", { className: "value" }, value)));
};
